export default {
  data() {
    return {
      modalResolve: null,
      modalReject: null,
    }
  },
  methods: {

    show(args) {
      return new Promise((resolve, reject) => {
        this.modalResolve = resolve
        this.modalReject = reject

        var modalOptions = {
          show: true
        }
        if(args) {
          if(args[1] !== undefined) {
            if(args[1].backdrop != undefined)
              modalOptions.backdrop = args[1].backdrop
            if(args[1].keyboard != undefined)
              modalOptions.keyboard = args[1].keyboard
          }
        } else {
          modalOptions.backdrop = 'static'
          modalOptions.keyboard = false
        }

        // Ignore the $ error (jQuery is defined)
        // eslint-disable-next-line
        $(this.$refs.dialog.$refs.modalDialog).modal(modalOptions)
      })
    },
    hide(callback) {
      // Setup hidden callback if requested
      if(typeof callback === 'function') {
        // eslint-disable-next-line
        $(this.$refs.dialog.$refs.modalDialog).one('hidden.bs.modal', () => {
          callback();
        });
      }

      // eslint-disable-next-line
      $(this.$refs.dialog.$refs.modalDialog).modal('hide')
    },

    modalClosed(result) {
      if(this.modalResolve) {
        this.modalResolve(result)
        this.modalResolve = null
      }
    }
  }
}
